// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__3-fhm","heading":"Container_heading__1xs98","years":"Container_years__3BAv8"};